const PdfStatus = Object.freeze({
  PENDING: 'PENDING',
  GENERATING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
})

export default PdfStatus
